import Chiclet from 'components/Chiclet/Chiclet';

export default Chiclet;
